import { createSlice } from "@reduxjs/toolkit";
import { getEnrollmentAgreementDetailsAPI } from "../../services/getEnrollmentAgreementDetails";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getEnrollmentAgreementDetailsSlice = createSlice({
  name: "getEnrollmentAgreementDetails",
  initialState,
  reducers: {
    getEnrollmentAgreementDetailsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getEnrollmentAgreementDetailsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "";
    },
    getEnrollmentAgreementDetailsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getEnrollmentAgreementDetailsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getEnrollmentAgreementDetailsHandler =
  (payload) => async (dispatch) => {
    try {
      dispatch(
        getEnrollmentAgreementDetailsAction.getEnrollmentAgreementDetailsInfo(
          payload,
        ),
      );
      const response = await getEnrollmentAgreementDetailsAPI(payload);
      dispatch(
        getEnrollmentAgreementDetailsAction.getEnrollmentAgreementDetailsInfoSuccess(
          response,
        ),
      );
    } catch (e) {
      dispatch(
        getEnrollmentAgreementDetailsAction.getEnrollmentAgreementDetailsInfoFailure(
          e?.response?.data?.message || e?.message || String(e),
        ),
      );
    }
  };

export default getEnrollmentAgreementDetailsSlice.reducer;
export const getEnrollmentAgreementDetailsAction =
  getEnrollmentAgreementDetailsSlice.actions;

